import { render, staticRenderFns } from "./DisplaySettingsPerAssignee.vue?vue&type=template&id=4f5e760c&scoped=true&"
import script from "./DisplaySettingsPerAssignee.vue?vue&type=script&lang=js&"
export * from "./DisplaySettingsPerAssignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5e760c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5e760c')) {
      api.createRecord('4f5e760c', component.options)
    } else {
      api.reload('4f5e760c', component.options)
    }
    module.hot.accept("./DisplaySettingsPerAssignee.vue?vue&type=template&id=4f5e760c&scoped=true&", function () {
      api.rerender('4f5e760c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PerAssignee/DisplaySettingsPerAssignee.vue"
export default component.exports